// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { push } from 'react-router-redux';
import { NavLink } from 'react-router-dom';


import * as selectors from '../../../reducers';
import LoginForm from '../../LoginForm';
import LoginError from '../../LoginError';
import LoginFormContainer from '../../LoginFormContainer';
import LoginFormTitle from '../../LoginFormTitle';
import LoginFormSubtitle from '../../LoginFormSubtitle';
import LoginContent from '../../LoginContent';
import CityFooter from '../../CityFooter';
import LoginLogo from '../../LoginLogo';
import SimpleMap from '../../SimpleMap';
import * as styles from './login.css'


type LoginViewPropTypes = {
  isAuthenticated: boolean,
  isAdmin: boolean,
  handleAuthenticated: boolean => void
};

class LoginView extends React.Component<LoginViewPropTypes> {
  componentDidMount() {
    const {
      isAuthenticated,
      handleAuthenticated,
      isAdmin,
    } = this.props;

    if (isAuthenticated) { handleAuthenticated(isAdmin); }
  }

  render() {
    return (
      <Fragment>
        <Grid fluid className={styles.login}>
          <Row start="xs">
            <Col xs={12} sm={12} md={5} lg={4}>
              <LoginFormContainer>
                <LoginLogo />
                <LoginFormSubtitle>
                  { 'Obtén completo control de tus buses escolares. ' }
                </LoginFormSubtitle>
                <LoginError />
                <LoginForm />
                <NavLink to="/forgot-password">
                  { '¿Olvidaste tu Contraseña?' }
                </NavLink>
              </LoginFormContainer>
            </Col>
            <Col
              xs={12} sm={12}
              md={7} lg={8}
              className={styles.content}>
              <LoginContent />
            </Col>
          </Row>
          <CityFooter />
        </Grid>
      </Fragment>
    );
  }
}


export default connect(
  state => ({
    isAuthenticated: selectors.isAuthenticated(state),
    isAdmin: true,
  }),
  dispatch => ({
    handleAuthenticated(isAdmin) {
      if (isAdmin) {
        dispatch(push('admin/backend/events'));
      } else {
        // LOGOUT?
      }
    },
  }),
)(LoginView);



// WEBPACK FOOTER //
// ./src/scripts/components/views/LoginView/index.jsx